export default "__VITE_ASSET___kBETEeNWcQRnw2XePR75w__"